import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import Login from './Login/Login';
import Home from './home/Home';
import Usuario from './usuario/Usuario';
import ListaPedido from './ListaPedido/ListaPedido';
import ListaAdiantamento from './ListaAdiantamento/ListaAdiantamento';
import ListaItemPedido from './ListaItemPedido/ListaItemPedido';
import ListaFolha from './ListaFolha/ListaFolha';
import ListaArquivosRede from './ListaArquivosRede';
import DetalheFolha from './ListaFolha/DetalheFolha';
import history from './history.js';
import PrivateRoute from './PrivateRoute';
import TrocaSenha from '../components/TrocaSenha/TrocaSenha';
import CadSenha from '../components/CadSenha/CadSenha'

const Routes = () => (
    <Router history={history}>
        <Switch>
            <Route exact path='/HOn' component={Login} />
            <Route exact path='/HOn/Home' component={Home} />
            <Route exact path='/HOn/CadSenha' component={CadSenha} />
            <PrivateRoute exact path='/HOn/Usuario' component={Usuario} />
            <PrivateRoute exact path='/HOn/ListaPedido' component={ListaPedido} />
            <PrivateRoute exact path='/HOn/ListaAdiantamento' component={ListaAdiantamento} />
            <PrivateRoute exact path='/HOn/ListaItemPedido/:NumPed' component={ListaItemPedido} />
            <PrivateRoute exact path='/HOn/ListaFolha' component={ListaFolha} />
            <PrivateRoute exact path='/HOn/DetalheFolha/:competencia' component={DetalheFolha} />
            <PrivateRoute exact path='/HOn/TrocaSenha' component={TrocaSenha} />
            <PrivateRoute exact path='/HOn/ListaArquivosRede' component={ListaArquivosRede} />
        </Switch>
    </Router>
)
export default Routes